<div>
  <h2>{{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ZUSTANDIGKEITSVEREINBARUNG.TITEL' | translate }}</h2>
  <div class="mb-3x mt-2x">
    <common-ui-card
      [message]="'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ZUSTANDIGKEITSVEREINBARUNG.INFO_TEXT' | translate"
      type="info">
    </common-ui-card>
  </div>
  <kapg-aus-lib-zustandigkeitsvereinbarung-form
    [(data)]="data"
    [readonly]="readonly">
  </kapg-aus-lib-zustandigkeitsvereinbarung-form>
</div>
